






























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {ErroIntegracaoFilterSchema} from '@/schema/filter/ErroIntegracaoFilterSchema'
import {ErroIntegracaoFilterCollection} from '@/model/filter/ErroIntegracaoFilterCollection'

@Component
export default class ErroIntegracaoFilter extends Vue {
  @Prop({type: Object, required: true}) filter!: ErroIntegracaoFilterCollection

  schema = new ErroIntegracaoFilterSchema()

  created() {
    this.applyFilter()
  }

  async applyFilter() {
    this.filter.resource = this.schema

    const promises: Array<Promise<any>> = [
      this.filter.resource.collectionResponsavel.listErroIntegracaoResponsavel(),
    ]

    await this.$await.run('adapQuery', () => Promise.all(promises))
  }

  async submitEvent() {
    this.$emit('submit')
    await this.$await.run('adapQuery', () => this.filter.queryAsPage())
  }
}
